import PropTypes from 'prop-types';
import ImageProp from './imageProp';
import UserPlanSubscriptionProp from './userPlanSubscriptionProp';

const propType = {
  _id: PropTypes.string,
  username: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  userNumber: PropTypes.number,
  email: PropTypes.string,
  password: PropTypes.string,
  genre: PropTypes.string,
  image: PropTypes.shape(ImageProp.propType),
  progressByBlock: PropTypes.shape({
    info: PropTypes.number.isRequired,
    company: PropTypes.number.isRequired,
    career: PropTypes.number.isRequired,
    experience: PropTypes.number.isRequired,
    hobbies: PropTypes.number.isRequired,
    softSkills: PropTypes.number.isRequired,
    hardSkills: PropTypes.number.isRequired,
    languages: PropTypes.number.isRequired,
    contacts: PropTypes.number.isRequired,
    moods: PropTypes.number.isRequired,
    media: PropTypes.number.isRequired,
    socialMedia: PropTypes.number.isRequired,
    legalFinances: PropTypes.number.isRequired,
  }),
  isTeamManager: PropTypes.bool,
  isAHost: PropTypes.bool,
  isATrainer: PropTypes.bool,
  userPlanSubscription: PropTypes.shape(UserPlanSubscriptionProp.propType),
  organizationHasUserPlans: PropTypes.bool,
  currencyIsBlocked: PropTypes.bool,
  userCanChangeEmail: PropTypes.bool,
  userCanChangeName: PropTypes.bool,
  connectors: PropTypes.shape({
    calendly: PropTypes.shape({
      config: PropTypes.shape({
        url: PropTypes.string,
      }),
      configured: PropTypes.bool,
    }).isRequired,
  }),
};

const defaultProp = {
  _id: '',
  username: '',
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  genre: '',
  image: ImageProp.defaultProp,
  isTeamManager: false,
  isAHost: false,
  isATrainer: false,
  userPlanSubscription: null,
  organizationHasUserPlans: false,
  currencyIsBlocked: false,
  userCanChangeEmail: true,
  userCanChangeName: true,
  connectors: {
    calendly: {
      configured: false,
      config: {},
    },
  },
};

const ROLES = {
  SUPER_ADMIN: 'super_admin',
  INSTANCE_ADMIN: 'instance_admin',
  ADMIN: 'admin',
  USER: 'user',
};

const TYPES = {
  COLLABORATOR: 'collaborator', // co-worker
  CUSTOMER: 'customer', // client
  LEAD: 'lead',
  RECOMMENDATION: 'recommendation',
  VISITOR: 'visitor',
};

const STATUS = {
  LIMITED: 'limited',
  INVITED: 'invited',
  ACTIVE: 'active',
};

const BINARY_PLACEMENT = {
  MANUAL: 'manual',
  AUTOMATIC_COMMISSION_RULES: 'automaticCommissionRules',
  AUTOMATIC_LEFT_LEG: 'automaticLeftLeg',
  AUTOMATIC_RIGHT_LEG: 'automaticRightLeg',
};

export default {
  propType,
  defaultProp,
  ROLES,
  TYPES,
  STATUS,
  BINARY_PLACEMENT,
};
